import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bugTypes: [],
  allBugTypes: [],
  cases: [],
};

export const messageCasesSlice = createSlice({
  name: "messageCases",
  initialState,
  reducers: {
    setBugTypes: (state, action) => {
      state.bugTypes = action.payload || [];
    },
    setAllBugTypes: (state, action) => {
      state.allBugTypes = action.payload;
    },
    setCases: (state, action) => {
      state.cases = action.payload || [];
    },
    addCase: (state, action) => {
      state.cases = [action.payload, ...state.cases];
    },
    updateCase: (state, action) => {
      state.cases = state.cases.map((e) => {
        if (e.id === action.payload.id) {
          return { ...e, ...action.payload };
        }
        return e;
      });
    },
  },
});

export const { setBugTypes, setCases, addCase, updateCase, setAllBugTypes } =
  messageCasesSlice.actions;

export const selectMessageCasesBugTypes = (state) =>
  state.messageCases.bugTypes;

export const selectAllMessageCasesBugTypes = (state) =>
  state.messageCases.allBugTypes;

export const selectMessageCases = (state) => state.messageCases.cases;

export default messageCasesSlice.reducer;
